import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';
import { IStoredCommandManager } from './IStoredCommandManager'
import { StoredCommandModel } from './StoredCommandModel';
import { StoredCommandSearchOptions } from './StoredCommandSearchOptions';

class StoredCommandManager implements IStoredCommandManager {

    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    save(model: StoredCommandModel): Promise<string | null> {

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/stored-commands/save',
            method: HttpMethod.POST
        }, model);

        return new Promise<string | null>((resolve, reject) => {
            this.manager
                .get<string[]>(req)
                .then((res) => {
                    resolve(res?.[0] ?? null);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    remove(id: string): Promise<undefined> {

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/stored-commands/remove/' + encodeURIComponent(id),
            method: HttpMethod.DELETE
        });

        return new Promise<undefined>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    if (res.ok) {
                        resolve(undefined);
                    } else {
                        reject(res.statusText);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }

    search(options: StoredCommandSearchOptions): Promise<StoredCommandModel[]> {
        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/stored-commands/search',
            method: HttpMethod.GET
        }, options);

        return new Promise<StoredCommandModel[]>((resolve, reject) => {
            this.manager
                .get<StoredCommandModel[]>(req)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }

    get(id: string): Promise<StoredCommandModel | null> {

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/stored-commands/get/' + encodeURIComponent(id),
            method: HttpMethod.GET
        });

        return new Promise<StoredCommandModel | null>((resolve, reject) => {
            this.manager
                .get<StoredCommandModel | null>(req)
                .then((res) => {
                    resolve(res as StoredCommandModel | null);
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    trigger(id: string): Promise<boolean> {

        let req = this.manager.createRequest({
            service: this.manager.api,
            path: '/tools/stored-commands/trigger/' + encodeURIComponent(id),
            method: HttpMethod.PUT
        });

        return new Promise<boolean>((resolve, reject) => {
            this.manager
                .send(req)
                .then((res) => {
                    resolve(res.ok);
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                })
        });
    }
}

export default (framework: IFramework) => {
    framework.registerTransient<IStoredCommandManager>('IStoredCommandManager', (frm) => {
        return new StoredCommandManager(frm)
    });
}